module.exports = __webpack_public_path__ + "static/together-6ebb23fc94459cdf7ad1a99b58177d19.jpeg";